import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for the modals slice
// This state keeps track of which modal is currently open
const initialState = {
  modalOpen: "intro", // By default, the 'intro' modal is open
};

// Create a slice for modals using Redux Toolkit's `createSlice` function
// A slice is a collection of Redux reducer logic and actions for a specific feature of the application
const modalsSlice = createSlice({
  // Name of the slice, used to prefix generated action types
  name: "modals",

  // The initial state of the slice, defined above
  initialState,

  // Reducers are functions that handle actions and update the state
  reducers: {
    /**
     * Reducer to open a specific modal or toggle it off if it's already open.
     * - Accepts an action with a payload of type `'settings' | 'bets' | 'info'`.
     * - If the modal specified in the payload is already open, it closes it by setting `modalOpen` to `null`.
     * - Otherwise, it sets `modalOpen` to the modal specified in the payload.
     */
    openModal(state, action) {
      // Toggle the modal state: if the specified modal is already open, close it; otherwise, open it
      state.modalOpen =
        state.modalOpen === action.payload ? null : action.payload;
    },

    /**
     * Reducer to close all modals.
     * - Resets `modalOpen` to `null`, ensuring no modal is open.
     */
    closeModal(state) {
      // Close all modals by setting `modalOpen` to null
      state.modalOpen = null;
    },
  },
});

// Export the actions generated by `createSlice` for use in components or middleware
// These actions can be dispatched to update the state
export const { openModal, closeModal } = modalsSlice.actions;

// Export the reducer function to be included in the Redux store
// The store will use this reducer to handle actions related to modals
export default modalsSlice.reducer;
